import { useState, useEffect } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

/**
 * Carga la tasa de cambio (Bs por USD) de la empresa.
 *
 * IMPORTANTE: debe pasarse `schemaName` (el schema de la empresa, con guiones bajos)
 * para que el backend lea `{schema}.apiia.tasa_cambio`. Sin schema, el endpoint
 * resuelve al fallback `negocio` (schema legacy/compartido) y devuelve una tasa
 * ajena a la empresa (bug de precio en bolivares).
 */
export function useTasa(schemaName) {
  const [tasaCambio, setTasaCambio] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const params = {};
    if (schemaName) params.schema_name = schemaName;
    axios
      .get(`${API_URL}/pedidos/config/tasa`, { params })
      .then((res) => {
        if (!cancelled && res.data.status === 'success' && res.data.data) {
          const parsed = parseFloat(res.data.data.tasa_cambio);
          setTasaCambio(Number.isFinite(parsed) ? parsed : null);
        }
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [schemaName]);

  return tasaCambio;
}
